import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import { cdnKeys } from '@teetsh/app/src/containers/CarnetsDeNotes/queries/keys';
import request from '@teetsh/app/src/utils/request';
import { deserializeEvaluation } from '@teetsh/app/src/containers/CarnetsDeNotes/queries/serializer';
import { useQuery } from '@tanstack/react-query';
import { useQueryErrorNotification } from 'containers/App/Notifications/useQueryErrorNotification';
import { useTranslation } from 'react-i18next';

function getEvaluation({
  schoolyearId,
  schoolId,
  cdnId,
  evaluationId,
}: {
  schoolyearId: string;
  schoolId: string;
  cdnId: string;
  evaluationId: string;
}) {
  const requestURL = `/schoolyears/${schoolyearId}/schools/${schoolId}/carnets-de-notes/${cdnId}/evaluations/${evaluationId}`;
  return request(requestURL, {
    method: 'GET',
  }).then(ev => deserializeEvaluation(ev));
}

export function useEvaluation(cdnId: string, evaluationId: string) {
  const { schoolyear, school } = useSchoolSchoolyear();
  const { t } = useTranslation(['carnet']);
  const query = useQuery({
    queryKey: cdnKeys.cdnEvaluationDetails(
      schoolyear.id,
      school.id,
      cdnId,
      evaluationId,
    ),
    queryFn: () =>
      getEvaluation({
        schoolyearId: schoolyear.id,
        schoolId: school.id,
        cdnId: cdnId,
        evaluationId,
      }),
    staleTime: 5 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
  });

  useQueryErrorNotification({
    isError: query.isError,
    message: t('carnet:messages.evaluation.getError_one'),
  });

  return query;
}
